import { createStore } from 'vuex'
import { ref } from 'vue'
export default createStore({
  state: {
    token:'',
    message:{},
    HistoryMessage:[],
    trainingPlan: null
  },

  mutations: {
      clearUser(state) {
        state.message = {}
      },
      SAVE_TRAINING_PLAN(state, data) {
        state.trainingPlan = data
      }
   
  },
  actions: {
  },
  getters: {
    // 方便后续页面取数据
    getTrainingPlan: (state) => state.trainingPlan
  }

})
